const urlRelatoriosLog = "/v1/RelatoriosDeLog";

const service = {
  methods: {
    $obterRelatorioLogGrupo(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogGrupo`, params);
    },
    $obterRelatorioLogCSVGrupo(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeGrupoCsv`, params);
    },
    $obterRelatorioLogPDFGrupo(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeGrupoPDF`, this.$getParamsObject(params));
    },
  }
};

export default service;